const ControlSeparator = () => {
	return <hr className="ugb-control-separator" />
}

export default ControlSeparator
